module.exports = __webpack_public_path__ + "img/135x90-01.c6ffd19a.png";